import { atomWithStorage } from 'jotai/utils';

export type SidebarState = {
  isOpen: boolean;
};

export const sidebarStateAtom = atomWithStorage<SidebarState>('courses-sidebar-state', { isOpen: true });
